module.exports = ReactI18next;